<template>
  <p-selection-child
    v-slot="{active, toggle}"
    tag="li"
    class="p-breadcrumb-dot"
    :disabled="disabled"
    @active="onActiveChange"
  >
    <component :is="disabled ? 'div' : 'a'" :class="{'p-breadcrumb-dot-link': true,'visited': isVisited, 'active': active, ...classList}" v-on="$listeners" @click="toggle">
      <span><slot></slot></span>
      <div class="line-left" :class="{'visited': isVisited, 'active': active, ...classListBG, ...classListLeftLine}"></div>
      <div class="line-right" :class="{'visited': isVisited, 'active': active, ...classListBG, ...classListRightLine}"></div>
      <div class="dot" :class="{'visited': isVisited, 'active': active, ...classListBG}"></div>
    </component>
  </p-selection-child>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    props: {
      value: { type: undefined, default: undefined },
      to: { type: String, default: undefined },
      color: { type: String, default: 'interaction' },
      activeColor: { type: String, default: 'positive' },
      visitedColor: { type: String, default: 'negative' },
      disabled: { type: Boolean, default: false },
    },
    data: () => ({
      isActive: false,
      isVisited: false,
    }),
    computed: {
      classListLeftLine(): Record<string, boolean> {
        if (this.isActive && !this.isVisited && !this.disabled) {
          return {
            [`color-${this.visitedColor}`]: this.isActive && !this.isVisited && !this.disabled,
            [`color-${this.activeColor}`]: false,
          };
        }
        return {};
      },
      classListRightLine(): Record<string, boolean> {
        if (this.isActive && !this.isVisited && !this.disabled) {
          return {
            [`color-${this.color}`]: this.isActive && !this.isVisited && !this.disabled,
            [`color-${this.activeColor}`]: false,
          };
        }
        return {};
      },

      classList(): {} {
        return {
          [`text-color-${this.color}`]: !this.isActive && !this.isVisited && !this.disabled,
          [`text-color-${this.activeColor}`]: this.isActive && !this.isVisited && !this.disabled,
          [`text-color-${this.visitedColor}`]: this.isVisited && !this.isActive && !this.disabled,
          'text-color-disabled': this.disabled,
          disabled: this.disabled,
        };
      },
      classListBG(): Record<string, boolean> {
        return {
          [`color-${this.color}`]: !this.isActive && !this.isVisited && !this.disabled,
          [`color-${this.activeColor}`]: this.isActive && !this.isVisited && !this.disabled,
          [`color-${this.visitedColor}`]: this.isVisited && !this.isActive && !this.disabled,
          'color-disabled': this.disabled,
          disabled: this.disabled,
        };
      },
    },
    methods: {
      onActiveChange(isActive: boolean) {
        this.isActive = isActive;
      },
    },
  });
</script>
